export default function toStartCase(text) {
    const words = text.split(" ");

    return words.map((word) => {
        if (word)
            return word[0].toUpperCase() + word.substring(1).toLowerCase();
    }).join(" ");
}